module.exports = __webpack_public_path__ + "static/media/xiaoshoujiqiao.dc6fe7d0.png";